import axios from 'axios';
import * as types from '../constants/ActionTypes';

const elmoURL = '/smarthelp/elmo-experiments';

export const requestElmoExperiments = () => ({
  type: types.ELMO_EXPERIMENTS_REQUESTED,
});

export const receivedElmoExperiments = (response) => ({
  type: types.ELMO_EXPERIMENTS_RECEIVED,
  payload: response,
});

export const elmoExperimentError = () => ({ type: types.ELMO_EXPERIMENTS_ERROR });

// Get ELMO Treatments using resource name
// eslint-disable-next-line no-unused-vars
export const getElmoExperiments = (resource) => (dispatch) => {
  const url = `${elmoURL}?resourceName=${resource}`;
  dispatch(requestElmoExperiments());
  return axios(url)
    .then((res) => {
      const treatments = (res.data && res.data.treatments) || [];
      dispatch(receivedElmoExperiments(treatments));
    })
    .catch(() => dispatch(elmoExperimentError()));
};
